import { FC, useCallback } from 'react'
import styles from 'components/features/creditCard/creditCardPage/Coaching/Coaching.styl'
import Button from 'components/features/pfm/Button/Button'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'

type CoachingProps = {
}
export const Coaching: FC<CoachingProps> = () => {
  const dispatch = useStoreDispatch()
  const handleScheduleSession = useCallback(() => {
    dispatch(modifyFloatingPaneActionCreator('advisor', {
      mode: 'request',
      step: 'topic',
      fields: {
        flow: 'regular',
      },
    }))
  }, [dispatch])

  return (
    <div className={ styles.coaching }>
      <div className={ styles.image } />
      <div className={ styles.text }>
        Take advantage of a monthly one-on-one video call with a certified financial advisor. Ask questions about any topic
        and get actionable advice you can use.
      </div>

      <div className={ styles.actions }>
        <Button
          fullWidth
          style='hollow'
          size='small'
          className={ styles.primaryAction }
          onClick={ handleScheduleSession }
        >
          SCHEDULE YOUR SESSION
        </Button>
        <NavigationLink to='coaching'>
          <Button style='textOnlyBig' fullWidth size='tiny'>Learn more about coaching</Button>
        </NavigationLink>
      </div>
    </div>
  )
}
